/*** IMPORTS FROM imports-loader ***/
(function() {

define([
    'pip-model',
    'pip-events',
    'thd-window'
],
function (
    pip,
    pipEvents,
    window
) {

    var DOM_elements = {};

    function bindDOM_elements() {

        DOM_elements.tabbed_content = window.document.querySelector('.tabbed-content');
        DOM_elements.buybelt = window.document.getElementById('buybelt-wrapper') && window.document.getElementById('buybelt-wrapper').parentNode;
        DOM_elements.specifications = window.document.getElementById('specifications');
        DOM_elements.product_description = window.document.getElementById('product_description');
        DOM_elements.citi_banner = window.document.getElementById('citi_offer');
        DOM_elements.certona_recommendations = window.document.getElementById('certona_recommendations');
        DOM_elements.pip_instock = window.document.getElementById('pip_instock_mobile');
        DOM_elements.IRG = window.document.getElementById('irg-containers-wrapper');
        DOM_elements.what_we_offer = window.document.querySelector('.what-we-offer');
        DOM_elements.installation_options = window.document.getElementById('installation_options');
        DOM_elements.required_items = window.document.getElementById('required_items');
    }

    function getRecommendationsInsertionPoint() {

        if (pip.viewModel.certona.isUnavailableScenario){
            return DOM_elements.buybelt ? DOM_elements.buybelt : DOM_elements.what_we_offer;
        }

        if (pip.flags.fbtDisplayed || pip.flags.irgHasChildren) {
            if (DOM_elements.citi_banner) {
                return DOM_elements.citi_banner;
            }
            if (pip.viewModel.page.hasTabs) {
                return DOM_elements.tabbed_content;
            }
            return DOM_elements.specifications;
        }

        return DOM_elements.buybelt ? DOM_elements.buybelt : DOM_elements.what_we_offer;
    }

    function getIRGInsertionPoint() {
        if (pip.flags.fbtDisplayed) {
            if (pip.viewModel.page.hasTabs) {
                return DOM_elements.tabbed_content;
            }
            return DOM_elements.product_description;
        } else if (DOM_elements.buybelt) {
            return  DOM_elements.installation_options ?  DOM_elements.installation_options : DOM_elements.buybelt
        } else {
            return DOM_elements.what_we_offer
        }
    }

    function positionCertonaRecommendations(el) {
        var recommendationsInsertionPoint = getRecommendationsInsertionPoint();
        if (el && recommendationsInsertionPoint) {
            recommendationsInsertionPoint.insertAdjacentElement('afterend', el);
        }
    }

    function positionIRG(el) {
        var IRGInsertionPoint = getIRGInsertionPoint();
        if (el && IRGInsertionPoint) {
            IRGInsertionPoint.insertAdjacentElement('afterend', el);
        }
    }

    function getRequiredItemsInsertionPoint() {
      if (pip.viewModel.certona.isUnavailableScenario) {
        return DOM_elements.certona_recommendations ? DOM_elements.certona_recommendations : DOM_elements.buybelt;
      }
      return DOM_elements.buybelt ? DOM_elements.buybelt : DOM_elements.what_we_offer;
    }

    function positionRequiredItems(el) {
      var requiredItemInsertionPoint = getRequiredItemsInsertionPoint();
      if (el && requiredItemInsertionPoint) {
        requiredItemInsertionPoint.insertAdjacentElement('afterend', el);
      }
    }

    return {

        init: function () {
            bindDOM_elements();
            if (pip.platform === 'MOBILE') {
                if (DOM_elements.pip_instock) {
                    positionCertonaRecommendations(DOM_elements.certona_recommendations);
                    positionRequiredItems(DOM_elements.required_items);
                  } else {
                    positionRequiredItems(DOM_elements.required_items);
                }
            } else {
                positionCertonaRecommendations(DOM_elements.certona_recommendations);
                positionIRG(DOM_elements.IRG);
                positionRequiredItems(DOM_elements.required_items);

                pipEvents.fbt.fbtInitComplete.off('.FBTPositioner');
                pipEvents.fbt.fbtInitComplete.on('.FBTPositioner', function () {
                    positionCertonaRecommendations(DOM_elements.certona_recommendations);
                    positionIRG(DOM_elements.IRG);
                    positionRequiredItems(DOM_elements.required_items);

                });
                pipEvents.irg.irgComplete.off('.IRGPositioner');
                pipEvents.irg.irgComplete.on('.IRGPositioner', function () {
                    positionCertonaRecommendations(DOM_elements.certona_recommendations);
                    positionRequiredItems(DOM_elements.required_items);
                });
            }
        },
        getRecommendationsInsertionPoint: getRecommendationsInsertionPoint,
        getIRGInsertionPoint: getIRGInsertionPoint,
        bindDOM_elements: bindDOM_elements,
        getRequiredItemsInsertionPoint: getRequiredItemsInsertionPoint
    }
});

}.call(window));